import { AreaResource, AreaType } from '../../area.resource';

export class AreaCoswinResource extends AreaResource {
   public static readonly TYPE =  AreaType.coswin;

   commesse: any[] = [];
   site: string = '';
   job: string = '';
   app_on_phone: boolean;
   type_user: any;
   notes: string = '';
   cid:string = '';
   phone:string = '';

   constructor() {
    super(AreaCoswinResource.TYPE);
   }
}

export class OrderResource {
  segment_code: string;
  project_name: string;
  project_description: string;
  active: boolean;
  cdc_type: string;
}

export class JobResource {
  description: string;
  id: number;
  value: string;
}


export class TypeUserResource{
  description: string;
  id: number;
  links: any[];
  value: string;
}